import { rootFontSize } from '../../cssVariables';

export const zIndices = {
  normal: 10,
  promoted: 20,
};

export const staticCircleOuterRadius = (2.5 * rootFontSize) / 2; // in pixels

export interface ISectionInfo {
  svgFileName: string;
  title: string;
  slideLabels: string[];
}

// Given the number of slides in each secdtion and the index of the current slide, figure out
// the `progress` of each section:
export const determineProgressForEachIcon = (relativeSlideIndex: number, info: ISectionInfo[]) => {
  let cumulativeSum = 0;
  const result: number[] = [];
  for (const {slideLabels} of info) {
    const numSlides = slideLabels.length;
    const cumulativeSumAtStart = cumulativeSum;
    const cumulativeSumAtEnd = cumulativeSum + numSlides;
    let currentProgress: number;
    if (relativeSlideIndex >= cumulativeSumAtEnd) {
      currentProgress = 100;
    } else if (relativeSlideIndex < cumulativeSumAtStart) {
      currentProgress = 0;
    } else {
      currentProgress = (relativeSlideIndex - cumulativeSumAtStart + 1) / numSlides * 100;
    }
    cumulativeSum = cumulativeSumAtEnd;
    result.push(currentProgress);
  }
  return result;
};

export const getSlideIndiciesBySection = (startingIndex: number, info: ISectionInfo[]) => {
  const result: number[][] = [];
  let counter = startingIndex;
  for (const {slideLabels} of info) {
    const numSlides = slideLabels.length;
    const indicesForSection: number[] = [];
    for (let i = 0; i < numSlides; i += 1) {
      indicesForSection.push(counter);
      counter += 1;
    }
    result.push(indicesForSection);
  }
  return result;
};
